import { parseDateString } from './utils';

export interface AgeGroupWithRange {
  id: string;
  group_name: string;
  sex: 'male' | 'female';
  birth_date_min: string;
  birth_date_max: string;
}

export function findProperAgeGroup(
  birthdate: string | undefined | null,
  sex: string | undefined | null,
  ageGroups: AgeGroupWithRange[]
): AgeGroupWithRange | null {
  if (!birthdate || !sex) return null;
  const dob = parseDateString(birthdate);
  if (isNaN(dob.getTime())) return null;

  return (
    ageGroups.find((g) => {
      if (g.sex !== sex) return false;
      const min = parseDateString(g.birth_date_min);
      const max = parseDateString(g.birth_date_max);
      return dob >= min && dob <= max;
    }) || null
  );
}

export function formatAgeGroupLabel(g: AgeGroupWithRange | null): string {
  if (!g) return '';
  return `${g.group_name} ${g.sex === 'male' ? 'Boys' : 'Girls'}`;
}
